import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.166 2.984a.7.7 0 0 1 .495.205l3.15 3.15a.7.7 0 0 1 0 .99l-8.4 8.4a.7.7 0 0 1-.326.185l-4.2 1.05a.7.7 0 0 1-.848-.85l1.05-4.2a.7.7 0 0 1 .184-.325l8.4-8.4a.7.7 0 0 1 .495-.205m-8.021 10.47-.467 1.868 1.868-.467zm2.77.79-2.16-2.16 7.41-7.41 2.16 2.16z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--selectedColor, currentColor)",
  d: "M4.984 20.316a.7.7 0 0 1 .7-.7h12.6a.7.7 0 1 1 0 1.4h-12.6a.7.7 0 0 1-.7-.7"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=HighlightChangesIcon24.js.map